import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

/** 외부(웹) 참석자 서명 전 입력 항목 — 소속·성명 (둘 다 필수) */
export const EMPTY_GUEST_SIGNER = { depNm: '', name: '' };

/** 입력 확인 — 문제가 있으면 안내 문구, 없으면 빈 문자열 */
export const ValidateGuestSigner = (value = EMPTY_GUEST_SIGNER) => {
  if (!String(value.depNm ?? '').trim()) return '소속을 입력해 주세요.';
  if (!String(value.name ?? '').trim()) return '성명을 입력해 주세요.';
  return '';
};

export default function GuestSignerFields({ value, onChange }) {
  const signer = value ?? EMPTY_GUEST_SIGNER;

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography sx={{ fontSize: '14px', color: '#828282' }}>
        참석자 확인을 위해 소속과 성명을 입력해 주세요.
      </Typography>
      <TextField
        size="small"
        required
        label="소속"
        placeholder="소속을 입력하세요"
        value={signer.depNm}
        inputProps={{ maxLength: 100 }}
        onChange={(e) => onChange({ ...signer, depNm: e.target.value })}
      />
      <TextField
        size="small"
        required
        label="성명"
        placeholder="성명을 입력하세요"
        value={signer.name}
        inputProps={{ maxLength: 20 }}
        onChange={(e) => onChange({ ...signer, name: e.target.value })}
      />
    </Box>
  );
}
